export default "__VITE_ASSET__ef4a73bc__"